// FadeTransition.js

import React, { useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';

const FadeTransition = ({ duration = 300, children }) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: duration,
      useNativeDriver: true,
    }).start();


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Animated.View style={{ opacity: fadeAnim, flex: 1 }}>
      {children}
    </Animated.View>
  );
};

export default FadeTransition;
